import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string | ReactNode;
  description?: string | ReactNode;
  actions?: ReactNode;
  image?: ReactNode | string;
  badge?: ReactNode;
  children?: ReactNode;
}

/**
 * PageHeader
 * Hiển thị Tiêu đề trang
 */
export function PageHeader({ title, description, actions, image, badge, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-4 lg:mb-6">
      <div className="min-w-0 flex-1 flex gap-5 items-start">
        {image && (
          <div className="flex-shrink-0 hidden sm:block">
            {typeof image === 'string' ? (
              <img src={image} alt="Thumbnail" className="w-20 h-20 lg:w-24 lg:h-24 rounded-md object-cover shadow-sm border border-slate-100 bg-slate-50" />
            ) : (
              image
            )}
          </div>
        )}
        <div className="min-w-0 flex-1">
        <div className="flex items-center gap-3">
          <h1 className="text-xl lg:text-2xl text-slate-800 tracking-tight flex items-center gap-3 leading-none">
            {title}
          </h1>
          {badge && <div className="flex-shrink-0 mt-1">{badge}</div>}
        </div>
        {description && (
          <div className="text-slate-500 mt-1.5 max-w-2xl sm:text-sm text-xs leading-relaxed">
            {description}
          </div>
        )}
        {children && <div className="mt-4">{children}</div>}
        </div>
      </div>
      
      {actions && (
        <div className="flex items-center gap-3 flex-shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
